module.exports = new __parcel__URL__("righteoushindrance.c0703628.png").toString();